export default {
    type: "form-radio-grid",
    style: "",
    data: {
      label: "New Radio Grid",
      rows: [
        { "label": "Statement1" },
        {"label": "Statement2"}
      ],
      cols: [
        { "value": "value1" },
        { "value": "value2" },
        { "value": "value3" },
      ],
    },
    children: [],
  };
